module.exports = __webpack_public_path__ + "static/media/calendar.c94dcde5.svg";